import { useEffect, useRef, useState, type FormEvent } from 'react';
import { t } from '../i18n/idioma';
import { useFechar } from '../input/useAtalhos';
import { Gump } from './Gump';
import { normalizeName } from '../api/types';

interface Props {
  name: string;
  busy: boolean;
  error: string | null;
  onCancel: () => void;
  onConfirm: (typed: string) => void;
}

export function DeleteModal({ name, busy, error, onCancel, onConfirm }: Props) {
  const [typed, setTyped] = useState('');
  const input = useRef<HTMLInputElement>(null);
  const match = normalizeName(typed).toLowerCase() === normalizeName(name).toLowerCase();

  useFechar(onCancel, { modal: true });
  useEffect(() => { input.current?.focus(); }, []);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (!match || busy) return;
    onConfirm(typed);
  };

  return (
    <div className="modal" role="presentation" onClick={onCancel}>
      <div role="dialog" aria-modal="true" aria-labelledby="del-title" onClick={e => e.stopPropagation()}>
        <Gump title={t('personagem.excluirTitulo')}>
          <form className="stack" onSubmit={submit}>
            <p id="del-title">
              {t('personagem.excluirAviso', { nome: name })}
            </p>
            <label className="field">
              <span className="field__label">{t('comum.nome')}</span>
              <input
                ref={input}
                value={typed}
                onChange={e => setTyped(e.target.value)}
                autoComplete="off"
                spellCheck={false}
                disabled={busy}
              />
            </label>
            {error && <p className="notice" role="alert">{error}</p>}
            <div className="row row--split">
              <button type="button" className="btn btn--ghost" onClick={onCancel} disabled={busy}>{t('comum.cancelar')}</button>
              <button type="submit" className="btn btn--danger" disabled={!match || busy}>
                {busy ? t('personagem.apagando') : t('personagem.excluirParaSempre')}
              </button>
            </div>
          </form>
        </Gump>
      </div>
    </div>
  );
}
